// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__1ge3w","Icon___large":"Icon_Icon___large__hnihw"};